






























import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import EditPostPage from './edit-post-page.vue'
import PageCard from '@/components/page-card.vue'
import Post from '@/store/entities/post'
class PostPageRequest extends PageRequest {
    keyword: string;
    categ: number[];
}
class MediaPageRequest extends PageRequest {
    keyword: string;
    type: string;
}
@Component({
    components: { PageCard }
})
export default class Posts extends AbpBase {
    //filters
    pagerequest: PostPageRequest = new PostPageRequest();
    mediaPageRequest: MediaPageRequest = new MediaPageRequest();
    createModalShow: boolean = false;
    editModalShow: boolean = false;
    categoriesForFilters: any = [];
    get list() {
        return this.$store.state.post.list;
    };
    get loading() {
        return this.$store.state.post.loading;
    }
    get categories() {
        return this.$store.state.post.categories;
    }
    get categ() {
        return this.$store.state.post.categ;
    }
    filterCategories() {
        var categories = [];
        this.$store.state.post.categories.forEach(singleElement => {
            categories.push({ "label": singleElement.name, "value": singleElement.id })
        });
        return categories;
    }
    async create() {
        const postId = '0';
        this.$router.push({ name: 'post', params: { postId } })
    }
    async edit(row) {
        const postId = row.id;
        console.log(row);
        this.$router.push({ name: 'post', params: { postId } })
    }
    pageChange(page: number) {
        this.$store.commit('post/setCurrentPage', page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit('post/setPageSize', pagesize);
        this.getpage();
    }
    setCategories(value) {
        this.$store.commit('post/setCurrentPage', 1);
        this.$store.commit('post/setCategories', value._filterChecked);
        this.pagerequest.categ = value._filterChecked
        this.getpage();
    }
    async search() {
        this.$store.commit('post/setCurrentPage', 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
        await this.$store.dispatch({
            type: "post/getAllCategories",
        }).then(async () => {
            this.categoriesForFilters = this.filterCategories();
            this.columns = this.cols;
            await this.$store.dispatch({
                type: 'post/getAll',
                data: this.pagerequest
            })
        })

        this.$store.commit('medialist/setPageSize', 16);
        this.mediaPageRequest.maxResultCount = this.pageSizeMedia;
        this.mediaPageRequest.skipCount = (this.currentPageMedia - 1) * this.pageSizeMedia;
        this.mediaPageRequest.type = "image"
        await this.$store.dispatch({
            type: 'medialist/getAll',
            data: this.mediaPageRequest
        })

    }
    get pageSize() {
        return this.$store.state.post.pageSize;
    }
    get totalCount() {
        return this.$store.state.post.totalCount;
    }
    get currentPage() {
        return this.$store.state.post.currentPage;
    }
    get pageSizeMedia() {
        return this.$store.state.medialist.pageSize;
    }
    get totalCountMedia() {
        return this.$store.state.medialist.totalCount;
    }
    get currentPageMedia() {
        return this.$store.state.medialist.currentPage;
    }
    get cols() {
        var setCats = this.setCategories;
        return [{
            title: this.L('Title'),
            key: 'title'
        },
        {
            title: this.L('Categories'),
            key: 'categories',
            filters: this.categoriesForFilters,
            render: (h: any, params: any) => {
                var el = h('div', [])
                params.row.categories.forEach(element => {
                    el.children.push(h('tag', element));
                });
                return el
            },
            filteredValue: this.categ,
            filterMethod(value, row) {
                return row;
            }
        },
        {
            title: this.L('Actions'),
            key: 'Actions',
            width: 150,
            render: (h: any, params: any) => {
                return h('div', [
                    h('Button', {
                        props: {
                            type: 'primary',
                            size: 'small',
                            icon: 'md-create'
                        },
                        style: {
                            marginRight: '5px'
                        },
                        on: {
                            click: () => {
                                this.edit(params.row);
                            }
                        }
                    }),
                    h('Button', {
                        props: {
                            type: 'error',
                            size: 'small',
                            icon: 'md-trash',
                        },
                        on: {
                            click: async () => {
                                this.$Modal.confirm({
                                    title: this.L('Tips'),
                                    content: this.L('DeletePostConfirm'),
                                    okText: this.L('Yes'),
                                    cancelText: this.L('No'),
                                    onOk: async () => {
                                        await this.$store.dispatch({
                                            type: 'post/delete',
                                            data: params.row
                                        })
                                        await this.getpage();
                                    }
                                })
                            }
                        }
                    })
                ])
            }
        }]
    }
    columns = []
    async created() {
        this.$store.commit('post/setCategories', []);
        this.getpage();
    }
}
